// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/poi.proto.
 */
export const file_travplaces_v1_poi: GenFile = /*@__PURE__*/
  fileDesc("Chd0cmF2cGxhY2VzL3YxL3BvaS5wcm90bxINdHJhdnBsYWNlcy52MSKHAwoDUG9pEgoKAmlkGAEgASgJEg8KB2NpdHlfaWQYAiABKAkSEwoLY2F0ZWdvcnlfaWQYAyABKAkSDAoEbmFtZRgEIAEoCRILCgNsYXQYBSABKAESCwoDbG5nGAYgASgBEg8KB2FkZHJlc3MYByABKAkSEwoLZGVzY3JpcHRpb24YCCABKAkSDgoGc291cmNlGAkgASgJEhEKCWlzX2FjdGl2ZRgKIAEoCBIuCgpjcmVhdGVkX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIUCgxjYXRlZ29yeV9rZXkYDCABKAkSFgoOY2F0ZWdvcnlfbGFiZWwYDSABKAkSEQoJY2l0eV9uYW1lGA4gASgJEhUKDWR3ZWxsX21pbnV0ZXMYDyABKAUSEwoGcmF0aW5nGBAgASgBSACIAQESDQoFcGhvbmUYESABKAkSDwoHd2Vic2l0ZRgSIAEoCRIVCg1vcGVuaW5nX2hvdXJzGBMgASgJQgkKB19yYXRpbmciKAoVTGlzdFBvaXNCeUNpdHlSZXF1ZXN0Eg8KB2NpdHlfaWQYASABKAkiOgoWTGlzdFBvaXNCeUNpdHlSZXNwb25zZRIgCgRwb2lzGAEgAygLMhIudHJhdnBsYWNlcy52MS5Qb2kijAEKFkNyZWF0ZU1hbnVhbFBvaVJlcXVlc3QSDwoHY2l0eV9pZBgBIAEoCRITCgtjYXRlZ29yeV9pZBgCIAEoCRIMCgRuYW1lGAMgASgJEgsKA2xhdBgEIAEoARILCgNsbmcYBSABKAESDwoHYWRkcmVzcxgGIAEoCRITCgtkZXNjcmlwdGlvbhgHIAEoCSI6ChdDcmVhdGVNYW51YWxQb2lSZXNwb25zZRIfCgNwb2kYASABKAsyEi50cmF2cGxhY2VzLnYxLlBvaSIeChBEZWxldGVQb2lSZXF1ZXN0EgoKAmlkGAEgASgJIhMKEURlbGV0ZVBvaVJlc3BvbnNlMsQCCgpQb2lTZXJ2aWNlEmoKDkxpc3RQb2lzQnlDaXR5EiQudHJhdnBsYWNlcy52MS5MaXN0UG9pc0J5Q2l0eVJlcXVlc3QaJS50cmF2cGxhY2VzLnYxLkxpc3RQb2lzQnlDaXR5UmVzcG9uc2UiC4rqMAMKAQqQ6jABEm0KD0NyZWF0ZU1hbnVhbFBvaRIlLnRyYXZwbGFjZXMudjEuQ3JlYXRlTWFudWFsUG9pUmVxdWVzdBomLnRyYXZwbGFjZXMudjEuQ3JlYXRlTWFudWFsUG9pUmVzcG9uc2UiC4rqMAMKAQyQ6jACElsKCURlbGV0ZVBvaRIfLnRyYXZwbGFjZXMudjEuRGVsZXRlUG9pUmVxdWVzdBogLnRyYXZwbGFjZXMudjEuRGVsZXRlUG9pUmVzcG9uc2UiC4rqMAMKAQyQ6jACQqMBChFjb20udHJhdnBsYWNlcy52MUIIUG9pUHJvdG9QAVovdHJhdnBsYWNlcy9nZW4vcHJvdG8vdHJhdnBsYWNlcy92MTt0cmF2cGxhY2VzdjGiAgNUWFiqAg1UcmF2cGxhY2VzLlYxygINVHJhdnBsYWNlc1xWMeICGVRyYXZwbGFjZXNcVjFcR1BCTWV0YWRhdGHqAg5UcmF2cGxhY2VzOjpWMWIGcHJvdG8z", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * Poi is a point of interest within a city.
 *
 * @generated from message travplaces.v1.Poi
 */
export type Poi = Message<"travplaces.v1.Poi"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * @generated from field: string category_id = 3;
   */
  categoryId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: double lng = 6;
   */
  lng: number;

  /**
   * @generated from field: string address = 7;
   */
  address: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * "osm" | "manual"
   *
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * What a picker needs to tell two alike places apart, and what a stop needs
   * to carry once chosen. The autocomplete's second line reads
   * "city · category · address", and a chosen place is added to a route with
   * its category's stay time — without these it showed a bare address and
   * planned a zero-minute stop.
   *
   * @generated from field: string category_key = 12;
   */
  categoryKey: string;

  /**
   * @generated from field: string category_label = 13;
   */
  categoryLabel: string;

  /**
   * set on cross-city searches, so hits are distinguishable
   *
   * @generated from field: string city_name = 14;
   */
  cityName: string;

  /**
   * @generated from field: int32 dwell_minutes = 15;
   */
  dwellMinutes: number;

  /**
   * @generated from field: optional double rating = 16;
   */
  rating?: number | undefined;

  /**
   * @generated from field: string phone = 17;
   */
  phone: string;

  /**
   * @generated from field: string website = 18;
   */
  website: string;

  /**
   * @generated from field: string opening_hours = 19;
   */
  openingHours: string;
};

/**
 * Describes the message travplaces.v1.Poi.
 * Use `create(PoiSchema)` to create a new message.
 */
export const PoiSchema: GenMessage<Poi> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 0);

/**
 * @generated from message travplaces.v1.ListPoisByCityRequest
 */
export type ListPoisByCityRequest = Message<"travplaces.v1.ListPoisByCityRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.ListPoisByCityRequest.
 * Use `create(ListPoisByCityRequestSchema)` to create a new message.
 */
export const ListPoisByCityRequestSchema: GenMessage<ListPoisByCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 1);

/**
 * @generated from message travplaces.v1.ListPoisByCityResponse
 */
export type ListPoisByCityResponse = Message<"travplaces.v1.ListPoisByCityResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.Poi pois = 1;
   */
  pois: Poi[];
};

/**
 * Describes the message travplaces.v1.ListPoisByCityResponse.
 * Use `create(ListPoisByCityResponseSchema)` to create a new message.
 */
export const ListPoisByCityResponseSchema: GenMessage<ListPoisByCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 2);

/**
 * @generated from message travplaces.v1.CreateManualPoiRequest
 */
export type CreateManualPoiRequest = Message<"travplaces.v1.CreateManualPoiRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string category_id = 2;
   */
  categoryId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: double lat = 4;
   */
  lat: number;

  /**
   * @generated from field: double lng = 5;
   */
  lng: number;

  /**
   * @generated from field: string address = 6;
   */
  address: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message travplaces.v1.CreateManualPoiRequest.
 * Use `create(CreateManualPoiRequestSchema)` to create a new message.
 */
export const CreateManualPoiRequestSchema: GenMessage<CreateManualPoiRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 3);

/**
 * @generated from message travplaces.v1.CreateManualPoiResponse
 */
export type CreateManualPoiResponse = Message<"travplaces.v1.CreateManualPoiResponse"> & {
  /**
   * @generated from field: travplaces.v1.Poi poi = 1;
   */
  poi?: Poi | undefined;
};

/**
 * Describes the message travplaces.v1.CreateManualPoiResponse.
 * Use `create(CreateManualPoiResponseSchema)` to create a new message.
 */
export const CreateManualPoiResponseSchema: GenMessage<CreateManualPoiResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 4);

/**
 * @generated from message travplaces.v1.DeletePoiRequest
 */
export type DeletePoiRequest = Message<"travplaces.v1.DeletePoiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeletePoiRequest.
 * Use `create(DeletePoiRequestSchema)` to create a new message.
 */
export const DeletePoiRequestSchema: GenMessage<DeletePoiRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 5);

/**
 * @generated from message travplaces.v1.DeletePoiResponse
 */
export type DeletePoiResponse = Message<"travplaces.v1.DeletePoiResponse"> & {
};

/**
 * Describes the message travplaces.v1.DeletePoiResponse.
 * Use `create(DeletePoiResponseSchema)` to create a new message.
 */
export const DeletePoiResponseSchema: GenMessage<DeletePoiResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi, 6);

/**
 * PoiService manages points of interest.
 *
 * @generated from service travplaces.v1.PoiService
 */
export const PoiService: GenService<{
  /**
   * ListPoisByCity returns the active POIs in a city.
   *
   * @generated from rpc travplaces.v1.PoiService.ListPoisByCity
   */
  listPoisByCity: {
    methodKind: "unary";
    input: typeof ListPoisByCityRequestSchema;
    output: typeof ListPoisByCityResponseSchema;
  },
  /**
   * CreateManualPoi adds a hand-entered POI (source = manual).
   *
   * @generated from rpc travplaces.v1.PoiService.CreateManualPoi
   */
  createManualPoi: {
    methodKind: "unary";
    input: typeof CreateManualPoiRequestSchema;
    output: typeof CreateManualPoiResponseSchema;
  },
  /**
   * DeletePoi removes a POI.
   *
   * @generated from rpc travplaces.v1.PoiService.DeletePoi
   */
  deletePoi: {
    methodKind: "unary";
    input: typeof DeletePoiRequestSchema;
    output: typeof DeletePoiResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_poi, 0);

